import React, { useEffect } from 'react';
import { number, string, func } from 'prop-types';
import { translate } from 'react-i18next';
import { compose } from 'redux';
import shave from 'shave';
import { connect } from 'react-redux';

import Link from '@blueberry/components/Link';

import { generatePostURL } from '@blueberry/redux/navigation';

import MediaImage from '@blueberry/components/MediaImage';
import { abbrivationFormat } from '@blueberry/utils/datetime';

import styles from './PostCard.scss';
const mapStateToProps = state => ({
  getPostURL: generatePostURL(state),
});

function PostCard({
  title,
  publishDate,
  mediaUrl,
  type,
  id,
  introText,
  mediaAltText,
  authorName,
  durationTime,
  urlTitle,
  getPostURL,
}) {
  const postURL = getPostURL({ title: urlTitle, id });

  useEffect(() => {
    shave(`.${styles.description}`, 52, {
      spaces: false,
    });

    shave(`.${styles.title}`, 60, {
      spaces: false,
    });
  }, []);
  return (
    <div className={styles.root}>
      <MediaImage
        mediaUrl={mediaUrl}
        durationTime={durationTime}
        type={type}
        href={postURL}
        mediaAltText={mediaAltText}
      />
      <Link title={title} to={postURL}>
        <h4 className={styles.title}>{title}</h4>
      </Link>
      <p className={styles.description}>{introText}</p>
      <div className={styles.infoBlock}>
        <span>{authorName}</span>
        <span className={styles.dot} />
        <span>{abbrivationFormat(publishDate)}</span>
      </div>
    </div>
  );
}
PostCard.propTypes = {
  authorName: string.isRequired,
  durationTime: number.isRequired,
  getPostURL: func.isRequired,
  id: string.isRequired,
  introText: string.isRequired,
  mediaAltText: string.isRequired,
  mediaUrl: string.isRequired,
  publishDate: string.isRequired,
  title: string.isRequired,
  type: string.isRequired,
  urlTitle: string.isRequired,
  className: string,
  mediaImageUrl: string,
};

export default compose(translate('home'), connect(mapStateToProps))(PostCard);



// WEBPACK FOOTER //
// ./app/components/PostCard/PostCard.jsx